// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X98Ft","colMin":"styles_colMin__1ECS1"};